import React, { useEffect, useRef } from 'react';
import './Article.scss';
import { gsap } from './gsap';
import { createPopper } from '@popperjs/core';
import Hero from './Components/Hero/Hero';
import Header from './Components/common-header/Header';
import Footer from './Components/common-footer/Footer';
import InlinePhoto from './Components/Photos/InlinePhoto';
import FullWidthPhoto from './Components/Photos/FullWidthPhoto';
import Chapter1 from './Components/Chapters/Chapter1';
import Chapter2 from './Components/Chapters/Chapter2';
import Chapter3 from './Components/Chapters/Chapter3';
import Chapter4 from './Components/Chapters/Chapter4';
import Chapter5 from './Components/Chapters/Chapter5';
import PullQuoteWImg from './Components/PullQuote/PullQuoteWImg';
import contents from './contents';
import CtaButton from './Components/CtaButton/CtaButton';
import FullWidthVideo from './Components/Photos/FullWidthVideo';

//for fullWidth Photos
import fullbleedPhoto2 from './Assets/fullbleedPhoto2.jpg';
import fullbleedPhoto2M from './Assets/fullbleedPhoto2M.jpg';
import fullbleedPhoto3 from './Assets/fullBleedPhoto3.jpg';
import fullbleedPhoto3M from './Assets/fullBleedPhoto3M.jpg';

//pullQuotePhotos
import pqImg1 from './Assets/pqImg1.jpg';

function Article({ heroBackgroundType, inlinePhotoSize, logoPlacement }) {
  //below states are for the audio player placement. See README for detail.

  //create refs for photos here if you want to add scale animation on scroll
  const inline1 = useRef();
  const inline2 = useRef();
  const inline3 = useRef();
  const inline4 = useRef();
  const inline5 = useRef();
  const inline6 = useRef();
  const inline7 = useRef();
  const allPhotosRef = useRef();
  allPhotosRef.current = [inline1, inline2, inline3, inline4, inline5, inline6, inline7]; // put all photo refs in this array

  const screenSizeRef = useRef(); //

  const photoSize = inlinePhotoSize !== undefined ? inlinePhotoSize : contents.inlinePhotos.size;

  //creates/shows tooltip element when mouse enters
  const handleMouseEnterTooltip = (e, currentRef) => {
    const content = currentRef.current;
    createPopper(e.target, content, {
      placement: 'bottom',
      modifiers: [
        {
          name: 'offset',
          options: {
            offset: [0, 5]
          }
        }
      ]
    });
    content.style.visibility = 'visible';
  };

  //hides tooltip element when mouse leaves
  const handleMouseLeaveTooltip = (currentRef) => {
    currentRef.current.style.visibility = 'hidden';
  };

  useEffect(() => {
    allPhotosRef.current.forEach((photo) => {
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: photo.current,
          start: '20% bottom',
          end: 'top center',
          scrub: 1
        }
      });
      tl.to(photo.current, {
        width: '100%',
        height: '100%',
        duration: 3
      });
    });
  }, []);

  return (
    <div className="article">
      <div className="height" ref={screenSizeRef} />
      <Header clientName={contents.header} />
      <Hero
        handleMouseEnterTooltip={handleMouseEnterTooltip}
        handleMouseLeaveTooltip={handleMouseLeaveTooltip}
        heroBackgroundType={heroBackgroundType}
        logoPlacement={logoPlacement}
      />
      <Chapter1 />
      <FullWidthVideo
        vidLink={'https://courageous-cdn-media-bucket.s3.amazonaws.com/basf/basfSwatch.mp4'}
        vidLinkM={'https://courageous-cdn-media-bucket.s3.amazonaws.com/basf/basfSwatchM.mp4'}
      />
      {/* <FullWidthPhoto
        photo={fullbleedPhoto1}
        photoM={fullbleedPhoto1}
        alt={'containers'}
        caption={''}
      /> */}
      <Chapter2 />

      <PullQuoteWImg
        quote={
          "The vehicle is an extension of your identity, your home, yourself, your family, and your culture, especially in America where it's a melting pot of people."
        }
        author={'Elizabeth Hoffman'}
        descrip={'Head of BASF Automotive Design for the Americas'}
        photo={pqImg1}
      />
      <FullWidthPhoto
        photo={fullbleedPhoto2}
        photoM={fullbleedPhoto2M}
        alt={'blue car'}
        caption={''}
      />
      <Chapter3 />
      <InlinePhoto
        photoSize={photoSize}
        photoContents={contents.inlinePhotos.contents[0]}
        photoRef={inline1}
      />

      <Chapter4 />

      <FullWidthPhoto
        photo={fullbleedPhoto3}
        photoM={fullbleedPhoto3M}
        alt={'blue car'}
        caption={''}
      />
      <Chapter5 />
      <CtaButton />
      <Footer />
    </div>
  );
}

export default Article;
